module.exports = __webpack_public_path__ + "static/kitchen.3a7e529e.jpg";